import React, { useMemo } from 'react';
import InputComponent from '@ui/components/Input/Input.component';
import ModalComponent from '@ui/components/Modal/Modal.component';
import ButtonComponent from '@ui/components/Button/Button.component';
import ButtonBarComponent from '@ui/components/Button-bar/Button-bar.component';
import ModalFormComponent from '@ui/components/Modal-form/Modal-form.component';
import { IProps } from './IProps';
import SendAgainComponent from '@ui/components/Send-again/Send-again.component';

const Component: React.FC<IProps> = ({
    lang,
    loading,
    code,
    codeError,
    confirmError,
    serverError,
    isAllowedToRequestAgain,
    timeToRequestAgain,
    sendedAgain,
    onCodeChange,
    onSendClick,
    onRequestConfirmClick,
    onInputClick,
    onBackClick,
    onKeyDown,
    onBtnKeyDown,
    onClose,
}: IProps) => {
    const errorMessage = useMemo(() => {
        if (codeError) return 'inputConfirmationCode';
        else if (confirmError) return 'wrongConfirm';
        else return '';
    }, [codeError, confirmError]);

    const alertMessage = useMemo(() => {
        if (serverError) return 'serverError';
        else if (sendedAgain) return 'confirmationHasBeenSendedAgain';
        else if (confirmError) return 'wrongConfirm';
        else return '';
    }, [serverError, sendedAgain, confirmError]);

    return (
        <ModalComponent
            className="confirm"
            title="confirmTitle"
            text="confirmText"
            alert={sendedAgain ? 'success' : 'error'}
            alertText={alertMessage}
            lang={lang}
            loading={loading}
            onBtnKeyDown={onBtnKeyDown}
            onBackClick={onBackClick}
            onClose={onClose}
        >
            <SendAgainComponent
                lang={lang}
                text="timerText"
                time={timeToRequestAgain}
            />
            <ModalFormComponent>
                <InputComponent
                    label="confirmationCode"
                    name="confirmation-code"
                    type="text"
                    errorMessage={errorMessage}
                    lang={lang}
                    value={code}
                    error={!!errorMessage}
                    onChange={onCodeChange}
                    onClick={onInputClick}
                    onFocus={onInputClick}
                    onKeyDown={onKeyDown}
                />
            </ModalFormComponent>
            <ButtonBarComponent>
                <ButtonComponent
                    label="send"
                    lang={lang}
                    onClick={onSendClick}
                    onKeyDown={onBtnKeyDown}
                />
                <ButtonComponent
                    color="warning"
                    label="requestAgain"
                    lang={lang}
                    disabled={!isAllowedToRequestAgain}
                    onClick={onRequestConfirmClick}
                    onKeyDown={onBtnKeyDown}
                />
            </ButtonBarComponent>
        </ModalComponent>
    );
};

const ConfirmComponent = React.memo(Component);

export default ConfirmComponent;
